import script from "./TagProductDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./TagProductDrawer.vue?vue&type=script&setup=true&lang=js"

import "./TagProductDrawer.vue?vue&type=style&index=0&id=3a76b019&lang=scss"

const __exports__ = script;

export default __exports__